// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * KITCHEN SURFACE IDENTITY (ADR-070, founder direction 2026-09-10).
 *
 * A drawn larder basket — weave, rim, handle. It depicts NO food and stands for
 * no ingredient, so it can never make a claim the data cannot back: this is
 * category B, and drawn rather than photographed, so even the provenance rule
 * does not come into it. It replaces the 🧺 emoji the web opt-in card used, and
 * it belongs to the Kitchen's own surfaces (opt-in, empty state) — never to the
 * Shop, whose cart stays visually distinct.
 *
 * The web twin of `LarderBasket` in `mobile/src/ui/ui.tsx`; the two draw the
 * same path data so the mark is one mark across the product.
 */
export function LarderBasket({ className = "size-11 text-ink-2" }: { className?: string }) {
  const stroke = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  }
  return (
    <svg viewBox="0 0 40 34" aria-hidden="true" className={className}>
      {/* the body, filled with the larder tone so the mark reads as an object, not a wire outline */}
      <path
        d="M5.5 12.5h29l-3 17a3 3 0 0 1-3 2.5H11.5a3 3 0 0 1-3-2.5z"
        fill="rgba(233,222,195,0.85)"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      {/* the weave — a basket is made of its weave */}
      <path
        d="M14 13.5 12.8 31M20 13.5V31M26 13.5 27.2 31M7.6 21.5h24.8"
        {...stroke}
        strokeWidth={1.1}
        opacity={0.55}
      />
      {/* the handle, arched over the rim */}
      <path d="M12.5 12.5a7.5 7.5 0 0 1 15 0" {...stroke} strokeWidth={1.5} />
      <path d="M4 12.5h32" {...stroke} strokeWidth={1.5} />
    </svg>
  )
}
